
import { defineComponent, onBeforeMount, reactive, PropType } from 'vue'

import NewModal from '@/common/new-components/NewModal/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

import { Courier, GetCouriersParams } from '@/new-services/types/couriers'

import couriersAPI from '@/new-services/couriers.service'

import useNotifications from '@/common/composable/useNotifications'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        NewModal,
        TheSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        dispatcherSectorIds: {
            type: Array as PropType<number[]>,
            default: () => [],
            required: true,
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            courier_id: null as number | null,
        })

        const validation$ = useVuelidate(
            {
                courier_id: { required },
            },
            state
        )

        const couriers_state = reactive({
            is_loading: false,
            is_failed: false,
            list: [] as Courier[],
        })

        const loadCouriers = async () => {
            try {
                couriers_state.is_loading = true

                const params: GetCouriersParams = {
                    page: 1,
                    limit: 9999,
                    statusIds: [2],
                    typesIds: [1],
                }
                if (props.dispatcherSectorIds) {
                    params.dispatcherSectorIds = props.dispatcherSectorIds
                }

                const response = await couriersAPI.getCouriers(params)
                couriers_state.list = response.data.data

                couriers_state.is_failed = false
            } catch (error) {
                console.error(error)
                couriers_state.is_failed = true
                notifications.notifyError({
                    error,
                    title: 'При получении списка курьеров произошла ошибка',
                })
            } finally {
                couriers_state.is_loading = false
            }
        }

        onBeforeMount(loadCouriers)

        const onSubmit = () => {
            if (props.loading) return

            validation$.value.$touch()
            if (validation$.value.$invalid) return

            emit('submit', state.courier_id)
        }

        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        return {
            state,
            validation$,
            couriers_state,
            loadCouriers,
            onSubmit,
            onCancel,
        }
    },
})
